module.exports = __webpack_public_path__ + "media/images/press_kit/four_seasons_yachts/email/top-small-2917fc2ce9c14659c3ecc1a6635cf7a6.png";